import { render, staticRenderFns } from "./formV.vue?vue&type=template&id=d151c814&scoped=true&"
import script from "./formV.vue?vue&type=script&lang=js&"
export * from "./formV.vue?vue&type=script&lang=js&"
import style0 from "./formV.vue?vue&type=style&index=0&id=d151c814&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d151c814",
  null
  
)

export default component.exports